import React, { useEffect, useRef, useState } from "react";
import АМР_4753_10 from "../../../../img/АМР_4753-10.png"
import АМР_4753_10_1 from "../../../../img/АМР_4753-10_1.png"
import АМР_4753_10_2 from "../../../../img/АМР_4753-10_2.png"
import АМР_4753_102 from "../../../../img/АМР_4753-102.png"
import АМР_4753_102_1 from "../../../../img/АМР_4753-102_1.png"
import АМР_4753_103 from "../../../../img/АМР_4753-103.png"
import АМР_4753_103_1 from "../../../../img/АМР_4753-103_1.png"
import АМР_4753_20 from "../../../../img/АМР_4753-20.png"
import АМР_4753_20_1 from "../../../../img/АМР_4753-20_1.png"
import АМР_4753_20_2 from "../../../../img/АМР_4753-20_2.png"
import АМР_4753_20_3 from "../../../../img/АМР_4753-20_3.png"
import АМР_4753_30 from "../../../../img/АМР_4753-30.png"
import АМР_4753_30_1 from "../../../../img/АМР_4753-30_1.png"
import АМР_4753_30_2 from "../../../../img/АМР_4753-30_2.png"
import АМР_4753_40 from "../../../../img/АМР_4753-40.png"
import АМР_4753_40_1 from "../../../../img/АМР_4753-40_1.png"
import АМР_4753_40_2 from "../../../../img/АМР_4753-40_2.png"
import questionPng from "../../../../img/question.png"
import classes from "./BriefDesc.module.css"
import Button from "../../../Button/Button";
import Arrow from "../../../../img/arrow.png"
import { NavLink, Router } from "react-router-dom";
import DSA from "../../../../docs.zip"


const BriefDesc = (props) => {
  const [gradient, setGradient] = useState("linear-gradient(0deg, rgba(255,255,255,0.01) 0%, rgba(0,0,0,0.64) 100%)")
  var imVarCount = "1"
  const [imageCount, setImageCount] = useState(imVarCount)
  const [characHeight, setCharacHeight] = useState("500px")
  const [characButt, setCharacButt] = useState("1")
  const [paramentsFetch, setParamentsFetch] = useState()
  const [maxCatId, setMaxCatId] = useState([])
  const [arrayParId, setArrayParId] = useState([])
  const [title, setTitle] = useState(props.title.length > 7 ? props.title.slice(0, -2) : props.title)
  const [titleDesc, setTitleDesc] = useState("Измерительный преобразователь гидростатического уровня АМР")
  const [changerValueAnimate, setChangerValueAnimate] = useState("")
  const [paramentsDoneId2, setParamentsDoneId2] = useState(props.title.length > 7 ? props.title.slice(8) == 2 ? "002" : props.title.slice(8) == 1 ? "001" : "000" : "000")
  const [paramentsDoneId3, setParamentsDoneId3] = useState("998")
  const [paramentsDoneId4, setParamentsDoneId4] = useState("415")
  const [paramentsDoneId5, setParamentsDoneId5] = useState("1")
  const [paramentsDoneId6, setParamentsDoneId6] = useState("613")
  const [paramentsDoneId7, setParamentsDoneId7] = useState("1")
  const [paramentsDoneId8, setParamentsDoneId8] = useState("20")
  const [paramentsDoneId9, setParamentsDoneId9] = useState("00")
  const [paramentsDoneId10, setParamentsDoneId10] = useState("000")
  const [paramentsDoneId11, setParamentsDoneId11] = useState("0")
  const [paramentsDoneId12, setParamentsDoneId12] = useState("1")
  const [paramentsDoneId13, setParamentsDoneId13] = useState("2")
  const [paramentsDonePar2, setParamentsDonePar2] = useState("Специальное исполнение")
  const [paramentsDonePar3, setParamentsDonePar3] = useState("специальный диапазон измерений (абс. давление)")
  const [paramentsDonePar4, setParamentsDonePar4] = useState("0…10 В")
  const [paramentsDonePar5, setParamentsDonePar5] = useState("С дисплеем")
  const [paramentsDonePar6, setParamentsDonePar6] = useState("Зажимное подключение Clamp DN 20 по DIN 32676")
  const [paramentsDonePar7, setParamentsDonePar7] = useState("До 120 градусов цельсия")
  const [paramentsDonePar8, setParamentsDonePar8] = useState("Нержавеющая сталь")
  const [paramentsDonePar9, setParamentsDonePar9] = useState("Без кабельного ввода")
  const [paramentsDonePar10, setParamentsDonePar10] = useState("Степень защиты IP 65")
  const [paramentsDonePar11, setParamentsDonePar11] = useState("Без заполняющей жидкости")
  const [paramentsDonePar12, setParamentsDonePar12] = useState("0,5%")
  const [paramentsDonePar13, setParamentsDonePar13] = useState("М20х1.5, нержавейка")
  const [paramentsCount, setParamentsCount] = useState("1")
  const [paramentsText, setParamentsText] = useState("")
  const [paramentsClick, setParamentsClick] = useState(0)
  const [paramentsINN, setParamentsINN] = useState("")
  const [paramentsOGRN, setParamentsOGRN] = useState("")
  const [paramentsTel, setParamentsTel] = useState("+7")
  const [paramentsName, setParamentsName] = useState("")
  const [paramentsEmail, setParamentsEmail] = useState("")
  const [paramentsLoading, setParamentsLoading] = useState(classes.closeLoad)
  const [errorFetch, setErrorFetch] = useState("")
  const [displayPopup, setDisplayPopup] = useState(classes.closerPopOrder)
  

  // refs
  const select1 = useRef(null);
  const select2 = useRef(null);
  const select3 = useRef(null);
  const select4 = useRef(null);
  const select5 = useRef(null);
  const select6 = useRef(null);
  const select7 = useRef(null);
  const select8 = useRef(null);
  const select9 = useRef(null);
  const select10 = useRef(null);
  const select11 = useRef(null);
  const select12 = useRef(null);
  const select13 = useRef(null);


  var ImgArray1 = ""
  var ImgArray2 = ""
  var ImgArray3 = ""
  var ImgArray4 = ""

  function id1 (e) {
    setTitle(e.target.value.split("=")[1])
    setTitleDesc(e.target.value.split("=")[2])
}
function id2 (e) {
    setParamentsDoneId2(e.target.value.split("=")[1])
    setParamentsDonePar2(e.target.value.split("=")[2])
}
function id3 (e) {
    setParamentsDoneId3(e.target.value.split("=")[1])
    setParamentsDonePar3(e.target.value.split("=")[2])
}
function id4 (e) {
    setParamentsDoneId4(e.target.value.split("=")[1])
    setParamentsDonePar4(e.target.value.split("=")[2])
}
function id5 (e) {
    setParamentsDoneId5(e.target.value.split("=")[1])
    setParamentsDonePar5(e.target.value.split("=")[2])
}
function id6 (e) {
    setParamentsDoneId6(e.target.value.split("=")[1])
    setParamentsDonePar6(e.target.value.split("=")[2])
}
function id7 (e) {
    setParamentsDoneId7(e.target.value.split("=")[1])
    setParamentsDonePar7(e.target.value.split("=")[2])
}
function id8 (e) {
    setParamentsDoneId8(e.target.value.split("=")[1])
    setParamentsDonePar8(e.target.value.split("=")[2])
}
function id9 (e) {
    setParamentsDoneId9(e.target.value.split("=")[1])
    setParamentsDonePar9(e.target.value.split("=")[2])
}
function id10 (e) {
    setParamentsDoneId10(e.target.value.split("=")[1])
    setParamentsDonePar10(e.target.value.split("=")[2])
}
function id11 (e) {
    setParamentsDoneId11(e.target.value.split("=")[1])
    setParamentsDonePar11(e.target.value.split("=")[2])
}
function id12 (e) {
    setParamentsDoneId12(e.target.value.split("=")[1])
    setParamentsDonePar12(e.target.value.split("=")[2])
}
function id13 (e) {
    setParamentsDoneId13(e.target.value.split("=")[1])
    setParamentsDonePar13(e.target.value.split("=")[2])
}

  useEffect(()=>{
    try {
        fetch(process.env.REACT_APP_FETCH_URL + "/api/paraments", {
            method: "GET",
            // headers: { 'Content-Type': 'application/json' },
        })
        .then((response)=>response.json())
        .then((response)=>{
            const elementsParams = []
            var arrCatId = []
            var arrParId = []
            Object.values(response).map((e)=>{
                const idE = e.id
                const idPrE = e.id_paraments
                const paramDescr = e.param_descr
                const catId = e.category_id
                if (catId !== 1) {arrCatId.push(catId)}
                arrParId.push(idE)
                elementsParams.push([idE, idPrE, paramDescr, catId])
            })
            arrCatId = new Set(arrCatId)
            arrCatId = Array.from(arrCatId)
            arrParId = new Set(arrParId)
            arrParId = Array.from(arrParId)
            setMaxCatId(arrCatId.sort((a, b) => a - b))
            setArrayParId(arrParId.sort((a, b) => a - b))
            setParamentsFetch(elementsParams.sort((a, b) => a[1] - b[1]))
        })
    } catch(e) {
        console.log(e)
    }
    setErrorFetch("")
  }, [])

  useEffect(()=>{
    setChangerValueAnimate(classes.changeValue)
    setTimeout(()=>{
        setChangerValueAnimate("")
    }, 1000)
  }, [paramentsDoneId2, paramentsDoneId3, paramentsDoneId4, paramentsDoneId5, paramentsDoneId6, paramentsDoneId7, paramentsDoneId8, paramentsDoneId9, paramentsDoneId10, paramentsDoneId11, setParamentsDoneId12])

  useEffect(()=>{
    if (paramentsINN !== "" && paramentsEmail !== "" && paramentsOGRN !== "" && paramentsEmail.includes("@") && paramentsClick !== 0) {
        setParamentsLoading(classes.viewLoad)
        try {
            fetch(process.env.REACT_APP_FETCH_URL + "/api/makeOrder", {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(query)
            }).then(()=>{
                setErrorFetch("Успешно отправлено")
                setParamentsCount("1")
                setParamentsEmail("")
                setParamentsINN("")
                setParamentsOGRN("")
                setParamentsText("")
                setParamentsTel("+7")
                setParamentsName("")
                setParamentsClick(0)
                setDisplayPopup(classes.closerPopOrder)
                setParamentsLoading(classes.closeLoad)
            })
        } catch (e) {
            console.log(e)
            setErrorFetch("Ошибка, попробуйте снова позже")
            setDisplayPopup(classes.closerPopOrder)
            setParamentsLoading(classes.closeLoad)
        }
    }
  }, [paramentsClick])

  useEffect(()=>{
    if (props.title.length > 7){
        if (props.title.slice(8) == 2) {
            setParamentsDoneId2("002")
        } else if (props.title.slice(8) == 3) {
            setParamentsDoneId2("001")
        } else {
            setParamentsDoneId2("000")
        }
    }
  }, [props.title])

    useEffect(() => {
            // const firstValue = select11.current.options[0].value;
            if (select13.current) {
                console.log(select6.current.options[0].value.split("=")[2])
                setParamentsDoneId2(select2.current.options[0].value.split("=")[1]);
                setParamentsDoneId3(select3.current.options[0].value.split("=")[1]);
                setParamentsDoneId4(select4.current.options[0].value.split("=")[1]);
                setParamentsDoneId5(select5.current.options[0].value.split("=")[1]);
                setParamentsDoneId6(select6.current.options[0].value.split("=")[1]);
                setParamentsDoneId7(select7.current.options[0].value.split("=")[1]);
                setParamentsDoneId8(select8.current.options[0].value.split("=")[1]);
                setParamentsDoneId9(select9.current.options[0].value.split("=")[1]);
                setParamentsDoneId10(select10.current.options[0].value.split("=")[1]);
                setParamentsDoneId11(select11.current.options[0].value.split("=")[1]);
                setParamentsDoneId12(select12.current.options[0].value.split("=")[1]);
                setParamentsDoneId13(select13.current.options[0].value.split("=")[1]);

                setParamentsDonePar2(select2.current.options[0].value.split("=")[2]);
                setParamentsDonePar3(select3.current.options[0].value.split("=")[2]);
                setParamentsDonePar4(select4.current.options[0].value.split("=")[3]);
                setParamentsDonePar5(select5.current.options[0].value.split("=")[4]);
                setParamentsDonePar6(select6.current.options[0].value.split("=")[5]);
                setParamentsDonePar7(select7.current.options[0].value.split("=")[6]);
                setParamentsDonePar8(select8.current.options[0].value.split("=")[7]);
                setParamentsDonePar9(select9.current.options[0].value.split("=")[8]);
                setParamentsDonePar10(select10.current.options[0].value.split("=")[9]);
                setParamentsDonePar11(select11.current.options[0].value.split("=")[10]);
                setParamentsDonePar12(select12.current.options[0].value.split("=")[11]);
                setParamentsDonePar13(select13.current.options[0].value.split("=")[12]);
            }
    }, [paramentsFetch, arrayParId]);

  window.addEventListener("scroll", () => {
    if (window.scrollY <= 100) {
      setGradient(
        "linear-gradient(0deg, rgba(255,255,255,0.01) 0%, rgba(0,0,0,0.64) 100%)"
      );
    } else {
      setGradient("");
    }
  });


    if (props.title.length > 7) {
        var type = props.title.slice(8)
    } else {
        var type = "1"
    }

    var parDesc = titleDesc + "<br/>" + paramentsDonePar2 + "<br/>" + paramentsDonePar3 + "<br/>" + paramentsDonePar4 + "<br/>" + paramentsDonePar5 + "<br/>" + paramentsDonePar6 + "<br/>" + paramentsDonePar7 + "<br/>" + paramentsDonePar8 + "<br/>" + paramentsDonePar9 + "<br/>" + paramentsDonePar10 + "<br/>" + paramentsDonePar13 + "<br/>" + paramentsDonePar11 + "<br/>" + paramentsDonePar12

    const query = {
        "parameter" : title + "/" + paramentsDoneId2 + "-" + paramentsDoneId3 + "-" + paramentsDoneId4 + "-" + paramentsDoneId5 + "-" + paramentsDoneId6 + "-" + paramentsDoneId7 + "-" + paramentsDoneId8 + "-" + paramentsDoneId9 + "/" + paramentsDoneId10 + "," + paramentsDoneId13 + "," + paramentsDoneId11 + "," + paramentsDoneId12,
        "textarea" : paramentsText === "" ? "*Пустое сообщение*" : paramentsText,
        "INN" : paramentsINN,
        "OGRN" : paramentsOGRN,
        "email" : paramentsEmail,
        "quantity" : paramentsCount,
        "tel" : paramentsTel,
        "name" : paramentsName,
        "description" : parDesc
      }

    if (title === "4753-10") {
        var error = 200
        if (type === "1") {
            var img = АМР_4753_10
            var ImgArray1 = АМР_4753_10_1
            var ImgArray2 = АМР_4753_10_2
        } else if (type === "2") {
            var img = АМР_4753_102
            var ImgArray1 = АМР_4753_102_1
        } else if (type === "3") {
            var img = АМР_4753_103
            var ImgArray1 = АМР_4753_103_1
        } else {
            var error = 404
        }
        
    } else if (title === "4753-20") {
        var error = 200
        var img = АМР_4753_20
        var ImgArray1 = АМР_4753_20_1
        var ImgArray2 = АМР_4753_20_2
        var ImgArray3 = АМР_4753_20_3
    } else if (title === "4753-30") {
        var error = 200
        var img = АМР_4753_30
        var ImgArray1 = АМР_4753_30_1
        var ImgArray2 = АМР_4753_30_2
    } else if (title === "4753-40") {
        var error = 200
        var img = АМР_4753_40
        var ImgArray1 = АМР_4753_40_1
        var ImgArray2 = АМР_4753_40_2
    } else {
        var error = 404
        var img = questionPng
    }
    if (error === 200) {
        return (
            <div className={classes.BriefDesc}>
                <div style={{background: gradient}} className={classes.headerGrad}></div>
                <div className={classes.contentBrief}> 
                    <div className={classes.imgBrief}>
                        <div className={classes.imgArr}>
                            {title === "4753-10" || title === "4753-20" || title === "4753-30" || title === "4753-40" ? <>
                                <div onClick={()=>{setImageCount("1")}} className={imageCount === "1" ? classes.thisImg : ""}><img src={img} alt="" /></div>
                                {ImgArray1 != "" ? <div onClick={()=>{setImageCount("2")}} className={imageCount === "2" ? classes.thisImg : ""}><img src={ImgArray1} alt="" /></div> : ""}
                                {ImgArray2 != "" ? <div onClick={()=>{setImageCount("3")}} className={imageCount === "3" ? classes.thisImg : ""}><img src={ImgArray2} alt="" /></div> : ""}
                                {ImgArray3 != "" ? <div onClick={()=>{setImageCount("4")}} className={imageCount === "4" ? classes.thisImg : ""}><img src={ImgArray3} alt="" /></div> : ""}
                                {ImgArray4 != "" ? <div onClick={()=>{setImageCount("5")}} className={imageCount === "5" ? classes.thisImg : ""}><img src={ImgArray4} alt="" /></div> : ""}
                            </> : <div className={imageCount === "1" ? classes.thisImg : ""}><img src={img} alt="" /></div>}
                        </div>
                        <div className={classes.mainImg}>
                            <img src={imageCount === "1" ? img : imageCount === "2" ? ImgArray1 : imageCount === "3" ? ImgArray2 : imageCount === "4" ? ImgArray3 : imageCount === "5" ? ImgArray4 : ImgArray2} alt={title} />
                        </div>
                    </div>
                    <div className={classes.textBrief}>
                        <div className={classes.mainText}>
                            <h1>AMP {title}</h1>
                            {title === "4753-10" ? <div className={classes.types}>
                                <h2>Тип</h2>
                                <div className={classes.typesDiv}>
                                    <NavLink onClick={()=>{setImageCount("1")}} to={"/ProductCard?4753-10/1"}><div className={type === "1" ? classes.thisType : ""}><img src={АМР_4753_10} alt="" /></div></NavLink>
                                    <NavLink onClick={()=>{setImageCount("1")}} to={"/ProductCard?4753-10/2"}><div className={type === "2" ? classes.thisType : ""}><img src={АМР_4753_102} alt="" /></div></NavLink>
                                    <NavLink onClick={()=>{setImageCount("1")}} to={"/ProductCard?4753-10/3"}><div className={type === "3" ? classes.thisType : ""}><img src={АМР_4753_103} alt="" /></div></NavLink>
                                </div>
                            </div> : ""}
                            
                                <h2>Описание</h2>{title === "4753-10" ? <h3>Преобразователи давления АМР-4753-10 предназначены для 
                                преобразования значений измеряемого давления в жидкостях и газах в унифицированный 
                                аналоговый выходной сигнал в виде силы постоянного тока, напряжения постоянного тока, и/или
                                цифровой выходной сигнал.</h3> : title === "4753-20" ? <h3>Преобразователи давления АМР-4753-20 предназначены для 
                                преобразования значений измеряемого давления в жидкостях и газах в унифицированный 
                                аналоговый выходной сигнал в виде силы постоянного тока, напряжения постоянного тока, и/или
                                цифровой выходной сигнал.</h3> : title === "4753-30" ? <h3>Преобразователи давления АМР-4753-30 предназначены для 
                                преобразования значений измеряемого дифференциального давления в жидкостях и газах с в 
                                унифицированный аналоговый выходной сигнал в виде силы постоянного тока, напряжения 
                                постоянного тока, и/или цифровой выходной сигнал.</h3> : title === "4753-40" ? <h3>Преобразователи давления АМР-4753-30 предназначены для 
                                преобразования значений измеряемого дифференциального давления в жидкостях и газах с в 
                                унифицированный аналоговый выходной сигнал в виде силы постоянного тока, напряжения 
                                постоянного тока, и/или цифровой выходной сигнал.</h3> : "Текст не найден"}
                                <br/>
                                <h3>Все приборы имеют Свидетельство об УТСИ № 94486-25 от 29.01.2025 г.</h3>
                        </div>
                        <div className={classes.buttons}>
                            <a href="#configure"><Button title="Заказать" bg="#2A4AC9" color="#fff"/></a>
                            <a href={DSA} download="docs"><Button href={DSA} title="Документы" bg="#F0F2FB" color="#000" alt="Скачать документы"/></a>
                        </div>
                    </div>
                </div>
                <div className={classes.characteristic}>
                    <div style={{height: characHeight}} className={classes.contentCharac}>
                        <h1>Характеристики</h1>
                        <div onClick={()=>{setCharacHeight("100%"); setCharacButt("2")}} style={{display: characButt === "1" ? "flex" : "none"}} className={classes.fullCharBatton}><button>Все характеристики <img src={Arrow} alt=">" style={{transform: "rotate(90deg)"}} /></button></div>
                        <div onClick={()=>{setCharacHeight("500px"); setCharacButt("1")}} style={{display: characButt === "2" ? "flex" : "none"}} className={classes.fullCharBatton}><button>Закрыть <img src={Arrow} alt=">" style={{transform: "rotate(-90deg)"}} /></button></div>
                        {title === "4753-10" ?
                        <table>
                            <tr><td>Базовый тип</td><td>4753-10 Измерительный преобразователь давления АМР</td></tr>
                            {/* <!-- <tr><td>Расширение базового типа</td><td>ExiaIICT4/T5/T6 по ГОСТ Р 52350.0; категория взрывоопасной смеси IIA, IIB, IIC, группы Т1…Т6 по ГОСТ Р 51330.11</td></tr> --> */}
                            <tr><td>Виды</td><td>Общепромышленное; Искробезопасное Exia; Взрывозащищенное Exid</td></tr>
                            <tr><td>Пределы погрешности преобразований</td><td>± 0,15; 0,25; 0,5 % / °С</td></tr>
                            <tr><td>Пределы погрешности от изменения температуры окружающей среды</td><td>±0,2 %/10 °С</td></tr>
                            <tr><td>Диапазон измерения</td><td>0...60 МПа</td></tr>
                            <tr><td>Выход</td><td>4…20 мА</td></tr>
                            <tr><td>Дисплей</td><td>С дисплеем / без дисплея</td></tr>
                            <tr><td>Тип рабочей измеряемой среды</td><td>газ / жидкость</td></tr>
                            <tr><td>Габаритные размеры, в зависимости от исполнения</td><td>высота от 5 до 200 мм; диаметр от 22 до 200 мм</td></tr>
                            <tr><td>Масса</td><td>от 0,1 до 3,5 кг</td></tr>
                            {/* <!-- <tr><td>Подключение к процессу (заподлицо)</td><td>G 1/4 по DIN EN 837</td></tr> --> */}
                            <tr><td>Температура измеряемой среды</td><td>+120 С°</td></tr>
                            {/* <!-- <tr><td>Материал подключения к процессу</td><td>Нержавеющая сталь</td></tr> --> */}
                            <tr><td>Электрическое питание</td><td>от постоянного тока от 11 до 28 В</td></tr>
                            <tr><td>Потребляемая мощность</td><td>от источника постоянного тока 0,88 В·А, не более</td></tr>
                            <tr><td>Типовые дополнения</td><td>Степень защиты IP 65</td></tr>
                            <tr><td>Условия эксплуатации</td><td>температура окружающего воздуха от - 65 до +85 °С<br/>относительная влажность от 30 до 85 %<br/>атмосферное давление от 86,6 до 106,7 кПа</td></tr>
                            <tr id="order"><td>Средний срок эксплуатации</td><td>20 лет</td></tr>
                            {/* <!-- <tr><td> </td><td> </td></tr> --> */}
                            {/* <!-- <tr id="order"><td>Жидкость</td><td>Силиконовое масло</td></tr> --> */}
                        </table>
                        : title === "4753-20" ? <table>
                        <tr><td>Базовый тип</td><td>4753-20 Измерительный преобразователь давления АМР</td></tr>
                            {/* <!-- <tr><td>Расширение базового типа</td><td>ExiaIICT4/T5/T6 по ГОСТ Р 52350.0; категория взрывоопасной смеси IIA, IIB, IIC, группы Т1…Т6 по ГОСТ Р 51330.11</td></tr> --> */}
                            {/* <!-- <tr><td>Виды</td><td>Общепромышленное; Искробезопасное Exia; Взрывозащищенное Exid</td></tr> --> */}
                            <tr><td>Пределы погрешности преобразований</td><td>± 0,15; 0,25; 0,5 % / °С</td></tr>
                            <tr><td>Пределы погрешности от изменения температуры окружающей среды</td><td>±0,2 %/10 °С</td></tr>
                            <tr><td>Диапазон измерения</td><td>0...60 МПа</td></tr>
                            <tr><td>Выход</td><td>4…20 мА</td></tr>
                            <tr><td>Дисплей</td><td>С дисплеем / без дисплея</td></tr>
                            <tr><td>Тип рабочей измеряемой среды</td><td>газ / жидкость</td></tr>
                            <tr><td>Габаритные размеры, в зависимости от исполнения</td><td>высота от 5 до 200 мм; диаметр от 22 до 200 мм</td></tr>
                            <tr><td>Масса</td><td>от 0,1 до 3,5 кг</td></tr>
                            {/* <!-- <tr><td>Подключение к процессу (заподлицо)</td><td>G 1/4 по DIN EN 837</td></tr> --> */}
                            <tr><td>Температура измеряемой среды</td><td>+120 С°</td></tr>
                            {/* <!-- <tr><td>Материал подключения к процессу</td><td>Нержавеющая сталь</td></tr> --> */}
                            <tr><td>Электрическое питание</td><td>от постоянного тока от 11 до 28 В</td></tr>
                            <tr><td>Потребляемая мощность</td><td>от источника постоянного тока 0,88 В·А, не более</td></tr>
                            <tr><td>Типовые дополнения</td><td>Степень защиты IP 65</td></tr>
                            <tr><td>Условия эксплуатации</td><td>температура окружающего воздуха от - 65 до +85 °С<br/>относительная влажность от 30 до 85 %<br/>атмосферное давление от 86,6 до 106,7 кПа</td></tr>
                            <tr id="order"><td>Средний срок эксплуатации</td><td>20 лет</td></tr>
                        </table> : title === "4753-30" ? <table>
                            <tr><td>Базовый тип</td><td>4753-30 Измерительный преобразователь давления АМР</td></tr>
                            <tr><td>Расширение базового типа</td><td>ExiaIICT4/T5/T6 по ГОСТ Р 52350.0; категория взрывоопасной смеси IIA, IIB, IIC, группы Т1…Т6 по ГОСТ Р 51330.11</td></tr>
                            <tr><td>Диапазон измерения</td><td>0...0,025 МПа (0…0,25 бар изб.)</td></tr>
                            <tr><td>Выход</td><td>4 -20 мА, 4-20 мА плюс HART, Modbus, Profibus, 0-5В; 0,4-5,5 В; 0-10В</td></tr>
                            <tr><td>Дисплей</td><td>С дисплеем</td></tr>
                            <tr><td>Подключение к процессу (заподлицо)</td><td>G 1/4 по DIN EN 837</td></tr>
                            <tr><td>Температура измеряемой среды</td><td>До 120 градусов цельсия</td></tr>
                            <tr><td>Материал подключения к процессу</td><td>Нержавеющая сталь</td></tr>
                            <tr><td>Электрическое подключение</td><td>Кабельный ввод, М20х1,5 латунь</td></tr>
                            <tr><td>Типовые дополнения</td><td>Степень защиты IP 65</td></tr>
                            <tr id="order"><td>Жидкость</td><td>Силиконовое масло</td></tr>
                        </table> : title === "4753-40" ? <table>
                            <tr><td>Базовый тип</td><td>4753-40 Измерительный преобразователь давления АМР</td></tr>
                            <tr><td>Расширение базового типа</td><td>ExiaIICT4/T5/T6 по ГОСТ Р 52350.0; категория взрывоопасной смеси IIA, IIB, IIC, группы Т1…Т6 по ГОСТ Р 51330.11</td></tr>
                            <tr><td>Диапазон измерения</td><td>0...0,025 МПа (0…0,25 бар изб.)</td></tr>
                            <tr><td>Выход</td><td>4 -20 мА, 4-20 мА плюс HART, Modbus, Profibus, 0-5В; 0,4-5,5 В; 0-10В</td></tr>
                            <tr><td>Дисплей</td><td>С дисплеем</td></tr>
                            <tr><td>Подключение к процессу (заподлицо)</td><td>G 1/4 по DIN EN 837</td></tr>
                            <tr><td>Температура измеряемой среды</td><td>До 120 градусов цельсия</td></tr>
                            <tr><td>Материал подключения к процессу</td><td>Нержавеющая сталь</td></tr>
                            <tr><td>Электрическое подключение</td><td>Кабельный ввод, М20х1,5 латунь</td></tr>
                            <tr><td>Типовые дополнения</td><td>Степень защиты IP 65</td></tr>
                            <tr id="order"><td>Жидкость</td><td>Силиконовое масло</td></tr>
                        </table> : "Характеристики не указаны" }
                    </div>
                </div>
                <div id="configure" className={classes.makeOrder}>
                    <div className={classes.contentOrder}>
                            <div className={classes.textOrder}>
                                <h1>Оформить заказ</h1>
                                <h2>Конфигурация измерительного прибора</h2>
                            </div>
                            <div className={classes.paraments}>
                                <h3>Маркировка: </h3>
                                    <h3 className={classes.mark + " " + changerValueAnimate}>
                                        {title + "/" + paramentsDoneId2 + "-" + paramentsDoneId3 + "-" + paramentsDoneId4 + "-" + paramentsDoneId5 + "-" + paramentsDoneId6 + "-" + paramentsDoneId7 + "-" + paramentsDoneId8 + "-" + paramentsDoneId9 + "/" + paramentsDoneId10 + "," + paramentsDoneId13 + "," + paramentsDoneId11 + "," + paramentsDoneId12}
                                    </h3>
                                    {maxCatId !== undefined ? maxCatId.map((catId) => {
                                        return (
                                            <span>
                                                {catId === 1 ? <h3>Базовый тип</h3> : catId === 2 ? <h3 className={title === "4753-10" ? classes.baseType : ""}>Расширение базового типа</h3> : catId === 3 ? <h3>Диапазон измерения</h3> : catId === 4 ? <h3>Выход</h3> : catId === 5 ? <h3>Дисплей</h3> : catId === 6 ? <h3>Подключение к процессу</h3>
                                                : catId === 7 ? <h3>Температура измеряемой среды</h3> : catId === 8 ? <h3>Материал подключения к процессу</h3> : catId === 9 ? <h3>Электрическое подключение</h3> : catId === 10 ? <h3>Типовые дополнения</h3> : catId === 11 ? <h3>Жидкость</h3> : catId === 12 ? <h3>Класс точности</h3> : catId === 13 ? <h3>Тип кабельного ввода</h3> : ""}
                                                <select 
                                                    onChange={(e)=>{
                                                        e.target.value.split("=")[0] === "1" ? id1(e) : e.target.value.split("=")[0] === "2" ? id2(e) : e.target.value.split("=")[0] === "3" ? id3(e) : e.target.value.split("=")[0] === "4" ? id4(e) : e.target.value.split("=")[0] === "5" ? id5(e) : e.target.value.split("=")[0] === "6" ? id6(e) : 
                                                        e.target.value.split("=")[0] === "7" ? id7(e) : e.target.value.split("=")[0] === "8" ? id8(e) : e.target.value.split("=")[0] === "9" ? id9(e) : e.target.value.split("=")[0] === "10" ? id10(e) : e.target.value.split("=")[0] === "11" ? id11(e) : e.target.value.split("=")[0] === "12" ? id12(e) : e.target.value.split("=")[0] === "13" ? id13(e) : id1(e)
                                                    }}
                                                    
                                                    ref={catId === 1 ? select1 : catId === 2 ? select2 : catId === 3 ? select3 : catId === 4 ? select4 : catId === 5 ? select5 : catId === 6 ? select6
                                                        : catId === 7 ? select7 : catId === 8 ? select8 : catId === 9 ? select9 : catId === 10 ? select10 : catId === 11 ? select11 : catId === 12 ? select12 : catId === 13 ? select13 : ""}


                                                    name={catId}  
                                                    
                                                    className={title === "4753-10" && catId === 2 ? classes.baseType : ""}
                                                >
                                                    {arrayParId.map((id1)=> {
                                                        return (
                                                            <>
                                                                {paramentsFetch[id1] !== undefined ? (catId === paramentsFetch[id1][3] ? <option value={paramentsFetch[id1][3] + "=" + paramentsFetch[id1][1] + "=" + paramentsFetch[id1][2]}>{paramentsFetch[id1][2]}</option> : undefined) : undefined}
                                                            </>
                                                        )
                                                    })}
                                                </select>
                                            </span>
                                        )
                                    }) : ""}
                            </div>

                            <div className={classes.formParaments}>
                                <form action="javascript:void(0);">
                                    <h3>Количество</h3>
                                    <span><input value={paramentsCount} required min="1" onChange={(e)=>{setParamentsCount(e.target.value)}} type="number" /></span>
                                    <h3>ИНН</h3>
                                    <span><input value={paramentsINN} required onChange={(e)=>{setParamentsINN(e.target.value)}} type="number" /></span>
                                    <h3>ОГРН</h3>
                                    <span><input value={paramentsOGRN} required onChange={(e)=>{setParamentsOGRN(e.target.value)}} type="number" /></span>
                                    <h3>Имя</h3>
                                    <span><input value={paramentsName} required onChange={(e)=>{setParamentsName(e.target.value)}} type="text" /></span>
                                    <h3>Телефон</h3>
                                    <span><input value={paramentsTel} required onChange={(e)=>{setParamentsTel(e.target.value)}} type="text" /></span>
                                    <h3>Почта</h3>
                                    <span><input value={paramentsEmail} required onChange={(e)=>{setParamentsEmail(e.target.value)}} type="email" /></span>
                                    <textarea value={paramentsText} onChange={(e)=>{setParamentsText(e.target.value)}} className={classes.commentForm} placeholder="Комментарий к заказу"></textarea>
                                    <h3 className={classes.mark}>{title + "/" + paramentsDoneId2 + "-" + paramentsDoneId3 + "-" + paramentsDoneId4 + "-" + paramentsDoneId5 + "-" + paramentsDoneId6 + "-" + paramentsDoneId7 + "-" + paramentsDoneId8 + "-" + paramentsDoneId9 + "/" + paramentsDoneId10 + "," + paramentsDoneId13 + "," + paramentsDoneId11 + "," + paramentsDoneId12}</h3>
                                    <p className={classes.error}>{errorFetch}</p>
                                    <div><Button onClick={()=>{paramentsINN !== "" && paramentsOGRN !== "" && paramentsEmail !== "" && paramentsEmail.includes("@") ? setDisplayPopup(classes.notCloserPopOrder) : setDisplayPopup(classes.closerPopOrder)}} title="Заказать"/></div>
                                </form>
                            </div>
                            <div className={classes.popupOrder + " " + displayPopup}>
                                    <div onClick={()=>{setDisplayPopup(classes.closerPopOrder)}} className={classes.backPopup}></div>
                                    <div className={classes.popup}>
                                        <div className={classes.contentPopup}>
                                        <div className={classes.loading + " " + paramentsLoading}><div className={classes.circle}></div></div>
                                            <div className={classes.textContentPopup}><h1>Заказ</h1></div>
                                            <div onClick={()=>{setDisplayPopup(classes.closerPopOrder)}} className={classes.closePopup}>+</div>
                                            <div className={classes.finishOrder}>
                                                <img src={title === "4753-10" ? АМР_4753_10 : title === "4753-20" ? АМР_4753_20 : title === "4753-30" ? АМР_4753_30 : title === "4753-40" ? АМР_4753_40 : ""} alt="" />
                                                <div className={classes.contentFinishOrder}>
                                                    <h2>{title + "/" + paramentsDoneId2 + "-" + paramentsDoneId3 + "-" + paramentsDoneId4 + "-" + paramentsDoneId5 + "-" + paramentsDoneId6 + "-" + paramentsDoneId7 + "-" + paramentsDoneId8 + "-" + paramentsDoneId9 + "/" + paramentsDoneId10 + "," + paramentsDoneId11 + "," + paramentsDoneId12}</h2>
                                                    <h3>{titleDesc}</h3>
                                                    <h3>{paramentsDonePar2}</h3>
                                                    <h3>{paramentsDonePar3}</h3>
                                                    <h3>{paramentsDonePar4}</h3>
                                                    <h3>{paramentsDonePar5}</h3>
                                                    <h3>{paramentsDonePar6}</h3>
                                                    <h3>{paramentsDonePar7}</h3>
                                                    <h3>{paramentsDonePar8}</h3>
                                                    <h3>{paramentsDonePar9}</h3>
                                                    <h3>{paramentsDonePar10}</h3>
                                                    <h3>{paramentsDonePar11}</h3>
                                                    <h3>{paramentsDonePar12}</h3>
                                                    <h3>{paramentsDonePar13}</h3>
                                                    <h2>Ваши данные:</h2>
                                                    <h3>{paramentsName}</h3>
                                                    <h3>{paramentsTel}</h3>
                                                    <h3>{paramentsEmail}</h3>
                                                    <h3>{paramentsINN}</h3>
                                                    <h3>{paramentsOGRN}</h3>
                                                    <textarea readonly value={paramentsText === "" ? "*Пустой комментарий*" : paramentsText}></textarea>
                                                    <div onClick={()=>{setParamentsClick(paramentsClick + 1)}} className={classes.divPopup}><Button title="Подтвердить заказ"/></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={classes.BriefDesc}>
                <h1>Страница не найдена</h1>
            </div>
        )
    }
}

// (e) => {return <><h1>dsd</h1></>}
{}

export default BriefDesc